import {APP_KEY,HTTP_URL} from "../../../util/constants";

//获取用户列表
export function getUserListRequest(namekey,status,offset,limit,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_user_list');
  formData.append("namekey",namekey);
  formData.append("status", status);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("offset", offset);
  formData.append("limit", limit);

  return fetch(HTTP_URL+'index.php/User/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//添加用户
export function addUserRequest(user_type,name,phone,pwd,initialPoints,status,beizhu,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'add_user');
  formData.append("user_type",user_type);
  formData.append("name", name);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("phone", phone);
  formData.append("pwd", pwd);
  formData.append("jifen", initialPoints);
  formData.append("status", status);
  formData.append("beizhu", beizhu);

  return fetch(HTTP_URL+'index.php/User/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//删除用户
export function delUserRequest(username,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'del_user');
  formData.append("username",username);

  return fetch(HTTP_URL+'index.php/User/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//禁用、启用用户
export function shouquanUserRequest(username,status,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'jinyong_qiyong_user');
  formData.append("username",username);
  formData.append("status",status);//(1:启用，3：禁用)；

  return fetch(HTTP_URL+'index.php/User/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//编辑用户
export function editUserRequest(user_type,name,phone,pwd,status,beizhu,username,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'update_user');
  formData.append("user_type",user_type);
  formData.append("name", name);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("phone", phone);
  formData.append("pwd", pwd);
  formData.append("status", status);
  formData.append("beizhu", beizhu);
  formData.append("username", username);

  return fetch(HTTP_URL+'index.php/User/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//获取用户信息
export function getUserInfoRequest(username,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_user_info');
  formData.append("username", username);

  return fetch(HTTP_URL+'index.php/User/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
